import { AlertNotification, Typography } from '@kar-dmp/ignite';
import {
	AffiliatePartnerDescription,
	AffiliatePartnerLogo,
	BannerContainer,
	LoadingContainer,
	LoadingSpinner,
	PartnerContent,
} from './styles';
import { useEffect, useState, useCallback } from 'react';
import { useRouter } from 'next/router';
import AffiliatePartnersService from 'services/affiliatePartners/affiliatePartners.service';

const AffiliatePartnerBanner = () => {
	const router = useRouter();
	const affiliatePartnerCode = router.query.affiliate_partner;

	const [partnerData, setPartnerData] = useState(null);
	const [partnerLoading, setPartnerLoading] = useState(false);

	const redirectToRegularSignup = useCallback(() => {
		const newQuery = { ...router.query };
		delete newQuery.affiliate_partner;
		router.replace({ pathname: '/sign_up', query: newQuery }, undefined, { shallow: true });
	}, [router]);

	const fetchPartnerData = useCallback(async () => {
		if (!affiliatePartnerCode) return;

		setPartnerLoading(true);
		try {
			const response = await AffiliatePartnersService.instance.getPartner(affiliatePartnerCode);
			if (response?.data) {
				setPartnerData(response.data);
			} else {
				redirectToRegularSignup();
				return;
			}
		} catch (error) {
			redirectToRegularSignup();
			return;
		} finally {
			setPartnerLoading(false);
		}
	}, [affiliatePartnerCode, redirectToRegularSignup]);

	useEffect(() => {
		fetchPartnerData();
	}, [fetchPartnerData]);

	if (partnerLoading) {
		return (
			<LoadingContainer>
				<LoadingSpinner aria-label="Loading affiliate partner" data-testid="blc-loader" />
			</LoadingContainer>
		);
	}

	if (!partnerLoading && partnerData) {
		return (
			<BannerContainer>
				<AlertNotification variant="banner" status="info">
					<PartnerContent>
						{partnerData.logo && (
							<AffiliatePartnerLogo src={partnerData.logo} alt={`${partnerData.name} logo`} />
						)}
						<AffiliatePartnerDescription>
							<Typography as="span" className="block" weight="bold">
								Congrats! You&apos;ve been invited to join by the {partnerData.name}!
							</Typography>
							<Typography as="span" className="block">
								Sign up today to start your journey with OPENLANE!
							</Typography>
						</AffiliatePartnerDescription>
					</PartnerContent>
				</AlertNotification>
			</BannerContainer>
		);
	}

	return null;
};

export default AffiliatePartnerBanner;
